import PropTypes from 'prop-types';
import React, { Component } from 'react';

import AdvertWrapper from 'modules/Common/components/AdvertWrapper';
import { toSlug } from 'utils';
import {localTimeShort} from 'utils/LocalDateTimeHelper';

import { GREYHOUND_RACE_COMPLETE_STATUSES } from 'modules/Common/consts';
import Tabs from 'modules/Common/components/Tabs';

import GreyhoundRacingRacecardSummary from './GreyhoundRacingRacecardSummary';
import GreyhoundRacingRacecardPreRace from './GreyhoundRacingRacecardPreRace';
import GreyhoundRacingRacecardPostRace from './GreyhoundRacingRacecardPostRace';
import RaceJSONLD from 'modules/Common/components/RaceJSONLD';

export default class GreyhoundRacingRacecardPage extends Component {
  static propTypes = {
    race: PropTypes.object,
    meeting: PropTypes.object
  };

  render() {
    const {
      race, // for passing on
      race: {
        race_summary: raceSummary, // for passing on
        race_summary : {
          race_summary_reference: {
            id: singleRaceId
          } = {},
          date : dateLong,
          race_stage: raceStage,
          winning_time : winningTime,
          off_time : offTime
        }
      },
      meeting: {
        meeting : [singleMeeting],
        meeting: [
          {
            meeting_summary: {
              course: {
                name: meetingCourseName = 'unknown'
              }
            },
            races: meetingRaces = []
          } = {}
        ]
      } = {}
    } = this.props;

    const tabs = meetingRaces.map(({
      race_summary_reference: {
        id: raceId
      },
      date: raceDate,
      time: raceTime
    }) => ({
      href: `/greyhounds/racecards/${dateLong}/${toSlug(meetingCourseName)}/racecard/${raceId}`,
      text: localTimeShort(`${raceDate}T${raceTime}Z`)
    }));

    return (
      <div>
        <RaceJSONLD meeting={singleMeeting} sport='greyhounds' type='racecard' raceId={singleRaceId}/>

        <section className='gh-racing-racecard-section'>
          <Tabs {...{tabs}}/>
          <GreyhoundRacingRacecardSummary {...{raceSummary}} />
        </section>

        { GREYHOUND_RACE_COMPLETE_STATUSES.includes(raceStage) ?
          <GreyhoundRacingRacecardPostRace {...{race, winningTime, offTime}}/>
        :
          <GreyhoundRacingRacecardPreRace {...{race}}/>
        }

        <AdvertWrapper ocSlot={["greyhounds", "leaderboard"]} additionalProperties={{view: "greyhounds"}} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/components/GreyhoundRacingRacecardPage.js